import { styled } from "styled-components";
import { Centering } from "styles/mixinStyles";

const HeaderContainer = styled(Centering)`
  background-color: #9999FF;
  height: 100px;
  width: 100vw;
  h2 {
    font-weight: 800;
    cursor: pointer;
  }
`;

export { HeaderContainer };

